import CustomerDashboard from '../../../components/customer/dashboard/CustomerDashboard'

const AEACustomerHome = () => {
    return <CustomerDashboard />
}

export default AEACustomerHome